import { AuthApi, UserApi } from 'services/api';
import React, { useState, useEffect } from 'react';

import { Alert } from 'rsuite';
import Form from '../../components/Form/index';
import PropTypes from 'prop-types';
import {useUser} from 'contexts/UserContext';
import Cookies from 'universal-cookie';
import { BookingApi } from 'services/api/booking';
import router from 'next/router';
import { createErrorStatusCodeHandler } from 'utils/default-http-error-handler';

export function Auth({ isPopup, mutateUser, setformAction }) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { mutateUser: muHandler } = isPopup ? { mutateUser } : useUser();
  useEffect(() => {
    const cookies = new Cookies();
    cookies.set('loginTo', isPopup ? `${window.location.pathname}${window.location.search}` : '/dashboard/bookings', {
      path: '/',
    });
  }, []);

  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({ email: '', passvghgvword: '' });

  const onFormSubmit = async event => {
    event.preventDefault();
    setLoading(true);
    const loginErrorHandler = createErrorStatusCodeHandler(
      'login',
      error => {
        Alert.error('Invalid Email or Password!', 5000);
      },
      error => {
        setLoading(false);
      }
    );
    AuthApi.login(formValue)
      .then(() => {
        UserApi.getCurrentUser()
          .then(user => {
            muHandler(user);
            if (user.data?.userType === 'renter') {
              BookingApi.fetchBookings('tenant')
                .then(res => {
                  if (res.data.length > 0) {
                    const userBooking = res.data.filter(
                      item =>
                        item.status === 'paid' || item.status === 'approved' || item.status === 'documents-uploaded'
                    );
                    router.push(`/my-bookings/${userBooking[0].id}`);
                  } else {
                    router.push('https://www.realsage.com/properties');
                  }
                })
                .catch(err => {
                  console.log(err);
                  setLoading(false);
                });
            }
          })
          .catch(loginErrorHandler);
      })
      .catch(loginErrorHandler);
  };

  return (
    <Form
      login
      titleText="Welcome"
      buttonText="Login"
      belowButtonText={isPopup ? "Don't have an account? Signup" : "Don't have an account? Request a product demo"}
      belowButtonLink={isPopup ? '/signup' : 'https://www.soulrooms.com/request-demo'}
      handleSubmit={onFormSubmit}
      isLoading={loading}
      onChangeFormValue={setFormValue}
      formValue={formValue}
      isPopup={isPopup}
      setformAction={setformAction}
    />
  );
}

Auth.propTypes = {
  showcasesData: PropTypes.object,
  getShowcases: PropTypes.func,
};

export default Auth;
